// Founder story, condensed from vimbal's full deck.

export const founder = {
  name: "Joshua Arnall",
  role: "Founder, CEO & Inventor",
  // Drop the portrait at public/founder/joshua-arnall.jpg. The monogram shows until it exists.
  photo: "/founder/joshua-arnall.jpg",
  eyebrow: "Founding story",
  titleLead: "From the mine site",
  titleEmphasis: "to the mind.",
  intro:
    "vimbal didn't start in a lab. It started in a study room built to survive law school after an accident that ended a mining career.",
  mission:
    "Creating opportunities for everyone, everywhere, to conquer challenges in work, education and health, so they can achieve their dreams and transform their lives.",
  chapters: [
    {
      when: "Early years",
      mark: "Roots",
      title: "A small-town start",
      body: "Raised in a farming and coastal town of 700 people, Joshua changed schools nine times and left before finishing Year 12. He worked as a farmhand, roustabout, tire fitter, shearer and furniture removalist, and played football, basketball and cricket.",
    },
    {
      when: "Mining",
      mark: "Mines",
      title: "Learning fast on site",
      body: "An electrical apprenticeship led to high-voltage, project and breakdown work on BHP sites, and then to gold room electrical specialist at Olympic Dam, where he was told he'd learned in six months what takes most people three years. He moved into construction in Western Australia and, at 25, became the youngest supervisor on a mine site of a few hundred people, later working on major mining construction projects.",
    },
    {
      when: "2014",
      mark: "2014",
      title: "Everything changed",
      body: "An accident caused 17 injuries to his spine, shoulder and hip. It ended his career, his trade and his sport, and meant seven years on a walking stick. Chronic anxiety, depression and PTSD followed, along with years of misdiagnosis and legal battles.",
    },
    {
      when: "2015",
      mark: "2015",
      title: "Law school, the hard way",
      body: "Needing an indoor career, and wanting to understand his own lawsuits, he entered law school. He'd read only three books since leaving school. So he studied neuroscience techniques, along with neuro-linguistic programming and hypnotherapy, to put pain and stress to one side, and built a distraction-free study room with sound and color immersion.",
    },
    {
      when: "Graduation",
      mark: "Law",
      title: "It worked",
      body: "Waking at 3am for five hours of focused flow before classes, he graduated in law and went on to work as a Judge's Associate in the industrial courts of South Australia.",
    },
    {
      when: "The question",
      mark: "XR",
      title: "Could it be built virtually?",
      body: "He wanted to teach these strategies to others, then asked whether the environment itself could be recreated in XR. Neuroscience researchers saw its potential for PTSD, and disability-sector experts pointed out that the same brain systems are involved in autism and ADHD.",
    },
    {
      when: "Today",
      mark: "Now",
      title: "vimbal",
      body: "Joshua invested his own savings, turned down a legal career and rebuilt the product several times to create vimbal's patent-filed cognitive engine. Today it runs on leading XR headsets and the web, has paying clients in mining, is in discussion with defense, and was named a 2025 top 30 company in Southern California.",
    },
  ],
  pullquote: "There were two choices: quit, or figure it out.",
  missionQuote:
    "I want to take vimbal to the world, so no one has to face the battles I faced during my rehabilitation and education.",
  numbers: [
    { value: 9, suffix: "", label: "schools before leaving in Year 12" },
    { value: 3, suffix: "", label: "books read in the 12 years before law school" },
    { value: 17, suffix: "", label: "injuries to his spine, shoulder and hip" },
    { value: 7, suffix: " yrs", label: "on a walking stick" },
    { value: 3, suffix: "am", label: "starts for five hours of focused study" },
    { value: 13, suffix: "+", label: "countries in vimbal's patent filing" },
  ],
  studyRoom: {
    eyebrow: "Then and now",
    titleLead: "The study room that",
    titleEmphasis: "became vimbal.",
    body: "Every part of vimbal started as something Joshua built to get himself through law school.",
    pairs: [
      { then: "A quiet room at home, cut off from distraction", now: "An immersive XR world that blocks out sensory noise" },
      { then: "Sound to settle the mind and hold focus", now: "Audio synced to reading pace and cognitive state" },
      { then: "Color to calm and steady attention", now: "A neurological color palette and neurodivergent modes" },
      { then: "Neuroscience techniques to set pain and stress aside", now: "A patent-filed cognitive engine that calms the stress center" },
      { then: "Hours of flow before dawn, every day", now: "Deep focus within minutes, for anyone" },
    ],
  },
  connect: {
    title: "Connect with Joshua",
    body: "For partnerships, site programs, research or media, reach out directly.",
  },
  goalLead: "Educate",
  goalEmphasis: "one billion people.",
  goalBody: "Safer workers. Smarter soldiers. Literate kids. Healthier minds.",
};
